// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1ycIA","upload":"Small_upload__1nT1E","imageWrap":"Small_imageWrap__15lyz","removeBtn":"Small_removeBtn__3MMN1"};